function checkExperiment(expName, callback) {
  if (typeof expName === 'object') {
    expName = I18n.country === 'US' ? expName.US : expName.EMEA;
  }

  window.Finch.experiment(expName, callback);
}

module.exports = checkExperiment;
